import { checkVersionAndDispatch } from "./extend";
import { dispatchSDK, getQueryObject } from "@/utils/extend";

export const getCurrentVersion = () => {
  const { version_name } = getQueryObject(window.location.href);
  console.log("version_name", window.location.href, version_name);
  return version_name || "0.0.0";
};

export const dispatchCloseWebview = (fallback: Function) => {
  const VERSION_LIMITS = ["3.1.1", "2.3.1"];
  const currentVersion = getCurrentVersion();
  const close = () => {
    dispatchSDK("closeWebView");
  };
  checkVersionAndDispatch(currentVersion, VERSION_LIMITS, close, fallback);
};
